import { useState, useMemo, useEffect } from "react";
import booksData from "../../data/books.json";
import "../overlay.css";

function BookOverlay({onClose}) {
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [cardsPerPage, setCardsPerPage] = useState(4);
    const [maxVisiblePages, setMaxVisiblePages] = useState(5);

    useEffect(() => {
        const mediaQuery = window.matchMedia("(max-width: 1096px)");

        const handleMediaChange = (e) => {
            setCardsPerPage(e.matches ? 3 : 4);
        };

        handleMediaChange(mediaQuery);
        mediaQuery.addEventListener("change", handleMediaChange);

        return () => mediaQuery.removeEventListener("change", handleMediaChange);
    }, []);

    const filteredBooks = useMemo(() => {
        return booksData
      .filter(book =>
        book.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        book.author.toLowerCase().includes(searchTerm.toLowerCase())
      )
      .sort((a, b) => a.author.localeCompare(b.author));
    }, [searchTerm]);

    const totalPages = Math.ceil(filteredBooks.length / cardsPerPage);

    useEffect(() => {
        const totalPages = Math.ceil(filteredBooks.length / cardsPerPage);
        if (currentPage > totalPages) {
            setCurrentPage(totalPages);
        }
    }, [cardsPerPage, filteredBooks, currentPage]);

    const getCurrentBooks = () => {
        const start = (currentPage - 1) * cardsPerPage;
        return filteredBooks.slice(start, start + cardsPerPage);
    };

    useEffect(() => {
        const updateMaxVisiblePages = () => {
            setMaxVisiblePages(window.innerWidth <= 455 ? 3 : 5);
        };

        updateMaxVisiblePages();

        window.addEventListener("resize", updateMaxVisiblePages);
        return () => window.removeEventListener("resize", updateMaxVisiblePages);
    }, []);

    const getPaginationRange = () => {
        const total = totalPages;
        const current = currentPage;
        const maxVisible = maxVisiblePages
        ;
        let start = Math.max(1, current - Math.floor(maxVisible / 2));
        let end = start + maxVisible - 1;
      
        if (end > total) {
          end = total;
          start = Math.max(1, end - maxVisible + 1);
        }
      
        return Array.from({ length: end - start + 1 }, (_, i) => start + i);
      };

      const handlePrev = () => {
        setCurrentPage((prevPage) => Math.max(1, prevPage - 1));
    };
    
      const handleNext = () => {
        setCurrentPage((prevPage) => Math.min(totalPages, prevPage + 1));
    };

    return (
        <div className="overlay">
            <div className="overlay-content">
                <button className="close-button" onClick={onClose}>×</button>
                <input
                    name="search field"
                    className="search-input"
                    type="search"
                    placeholder="Suche nach Autor:in oder Titel"
                    value={searchTerm}
                    onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(1);
                      }}
                />
                {filteredBooks.length > 0 ? (
                    <div className="carousel">
                        <div className="book-cards-container">
                            {getCurrentBooks().map((book, index) => (
                                <div className="book-card" key={index}>
                                    <h3>{book.author}</h3>
                                    <p>{book.title}</p>
                                </div>
                            ))}
                        </div>
                        <div className="carousel-button-container">
                            <button className="carousel-button" onClick={() => setCurrentPage(1)} disabled={currentPage === 1}>
                                &#10094;&#10094; 
                            </button>
                            <button className="carousel-button" onClick={handlePrev}>
                                &#10094;
                            </button>
                            <div className="pagination">
                                {getPaginationRange().map((pageNum) => (
                                <button
                                    key={pageNum}
                                    className={`page-button ${currentPage === pageNum ? "active" : ""}`}
                                    onClick={() => setCurrentPage(pageNum)}
                                >
                                    {pageNum}
                                </button>
                                ))}
                            </div>
                            <button className="carousel-button" onClick={handleNext}>
                                &#10095;
                            </button>
                            <button className="carousel-button" onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages}>
                                &#10095;&#10095;
                            </button>
                        </div>
                    </div>
                ) : (
                    <div className="no-results">
                        <p>Keine Bücher gefunden</p>
                        <img src="\assets\no-books-found.png" alt="Keine Bücher gefunden"/>
                    </div>
                )}
            </div>
        </div>
    );
}

export default BookOverlay;